import React from "react";
import { Button, Col, Form, InputGroup, Row } from "react-bootstrap";

export default function SettingForm({ setting, error, t, onChange, onAdd }) {
  return (
    <Form className="mb-4">
      <Row className="align-items-center">
        <Col md={4}>
          <InputGroup>
            <InputGroup.Text>{t("name")}</InputGroup.Text>
            <Form.Control
              name="name"
              value={setting.name}
              onChange={onChange}
              placeholder={`${t("exampleShort")} ${t("width")}`}
            />
          </InputGroup>
        </Col>
        <Col md={4}>
          <InputGroup>
            <InputGroup.Text>{t("settingsValue")}</InputGroup.Text>
            <Form.Control
              name="value"
              value={setting.value}
              onChange={onChange}
              placeholder={`${t("exampleShort")} 100`}
            />
          </InputGroup>
        </Col>
        <Col md="auto">
          <Button variant="primary" onClick={onAdd}>
            {t("settingsAdd")}
          </Button>
        </Col>
      </Row>
      {error && <p className="text-danger mt-2">{error}</p>}
    </Form>
  );
}
